<template>
	<v-card class="device-manager fill-wh" :loading="loading">
		<v-toolbar class="toolbar">
			<v-btn
				v-if="!!selectedNode && $vuetify.breakpoint.smAndDown"
				icon
				@click="selectedNode = null"
			>
				<v-icon>fas fa-times</v-icon>
			</v-btn>

			<v-toolbar-title>
				{{ dialogTitle }}
			</v-toolbar-title>

			<template v-if="showDetails">
				<v-btn icon class="btn--info">
					<v-icon color="ocean lighten-1">fas fa-info-circle</v-icon>
				</v-btn>
				<tippy to-selector=".btn--info" v-bind="tippyAttrs" arrow>
					<device-info-table :guid="selectedNode" />
				</tippy>
			</template>

			<v-spacer />

			<!-- Edit icon? -->
		</v-toolbar>

		<div class="master-detail-container">
			<layout-master-detail :show-details="showDetails">
				<DevicesList v-model="selectedNode" />

				<template #detail>
					<DevicesSidebar :node-guid="selectedNode" />
				</template>
			</layout-master-detail>
		</div>

		<!-- Speed Dial -->
		<device-speed-dial
			:show-filter="false"
			fixed
			@action:addDevice="addDevice"
			@action:addRoom="addRoom"
		/>

		<!-- Dialogs -->
		<device-dialog-add-device ref="addDeviceDialog" :rooms="rooms" />
		<device-dialog-add-room ref="addRoomDialog" />
	</v-card>
</template>

<style lang="scss" scoped>
.master-detail-container {
	position: relative;
	min-height: calc(100% - 56px); // 56px toolbar

	@media #{map-get($display-breakpoints, 'md-and-up')} {
		min-height: calc(100% - 64px); // 64px toolbar
	}
}
</style>

<script>
import { mapActions, mapGetters } from "vuex";

import DevicesList from "../detail/system/DevicesList";
import DevicesSidebar from "../detail/system/DevicesSidebar";

export default {
	components: {
		DevicesList,
		DevicesSidebar,
	},

	beforeRouteEnter(to, from, next) {
		return next(vm => {
			vm.loadRemoteController(vm.system.id);
		});
	},

	beforeRouteLeave(to, from, next) {
		// Make sure we disconnect from controller before leaving
		this.$store.commit("controller/resetState");
		return next();
	},

	data: () => ({
		selectedNode: null,
	}),

	computed: {
		...mapGetters({
			system: "session/system",
			nodeByGuid: "controller/nodes/nodeByGuid",
			roomsLive: "controller/nodes/rooms",
			roomsLocal: "devices/rooms",
		}),

		loading() {
			return this.$store.getters["controller/connecting"];
		},

		isLocal() {
			return !!this.$store.state.controller.local;
		},

		rooms() {
			return this.isLocal ? this.roomsLocal : this.roomsLive;
		},

		dialogTitle() {
			if (this.selectedNode) {
				return this.nodeByGuid(this.selectedNode).name;
			}

			return "Devices";
		},

		showDetails() {
			return !!this.selectedNode;
		},

		tippyAttrs() {
			return {
				visible: true,
				interactive: true,
				placement: "bottom",
				trigger: "click",
				maxWidth: 650,
				zIndex: 300,
			};
		},
	},

	methods: {
		...mapActions({
			loadRemoteController: "controller/loadRemote",
			doAdd: "controller/nodes/add",
		}),

		addDevice() {
			return this.$refs.addDeviceDialog.pop(this.doAdd);
		},

		addRoom() {
			return this.$refs.addRoomDialog.pop(this.doAdd);
		},
	},
};
</script>
